// removed by extract-text-webpack-plugin
module.exports = {"tasks-panel-title":"index__tasks-panel-title___2Ml5l","tasks-card-wrapper":"index__tasks-card-wrapper___2BXLE","card-content-label":"index__card-content-label___12bMh","card-content-value":"index__card-content-value___3j5x3"};


//////////////////
// WEBPACK FOOTER
// ./src/views/ObjectTask/index.less
// module id = 549
// module chunks = 3